import React, { useEffect, useState, useRef } from "react";
import $ from "jquery";
import PerfectScrollbar from "perfect-scrollbar";
import feather from "feather-icons";

const Chatbot = () => {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(false);
    const scrollRef = useRef(null);

    useEffect(() => {
        new PerfectScrollbar("#scroll", { suppressScrollX: true });
        feather.replace();
    }, []);

    // Auto scroll to bottom
    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [messages]);

    const sendMessage = async () => {
        let prompt = $("#prompt").val();
        if (!prompt.trim()) return;

        // Add user message
        const userMessage = {
            role: "user",
            content: prompt,
            time: new Date().toLocaleTimeString(),
        };
        setMessages((prev) => [...prev, userMessage]);
        $("#prompt").val("");

        // Prepare empty AI message slot
        const aiMessage = {
            role: "assistant",
            content: "",
            time: new Date().toLocaleTimeString(),
        };
        setMessages((prev) => [...prev, aiMessage]);

        setLoading(true);

        try {
            const res = await fetch("https://ai.postflow.social/api/generate", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    model: "gemma3:4b",
                    prompt: prompt,
                    stream: true,
                }),
            });

            const reader = res.body.getReader();
            const decoder = new TextDecoder();

            let runningText = "";

            while (true) {
                const { value, done } = await reader.read();
                if (done) break;

                const chunk = decoder.decode(value);
                const lines = chunk.split("\n").filter((l) => l.trim() !== "");

                for (let line of lines) {
                    const json = JSON.parse(line);

                    if (json.response) {
                        runningText += json.response; // append chunk

                        // Update LAST AI message with the new text
                        setMessages((prev) => {
                            const updated = [...prev];
                            updated[updated.length - 1] = {
                                ...updated[updated.length - 1],
                                content: runningText,
                            };
                            return updated;
                        });
                    }
                }
            }
        } catch (error) {
            console.error("Stream error:", error);

            setMessages((prev) => [
                ...prev,
                {
                    role: "assistant",
                    content: "❌ Error connecting to AI server.",
                    time: new Date().toLocaleTimeString(),
                },
            ]);
        }

        setLoading(false);
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            sendMessage();
        }
    };

    return (
        <div className="content-body">
            <div className="chat-wrapper chat-wrapper-two pos-relative h-100" style={{ background: "white" }} id="scroll" ref={scrollRef}>
                <div className="chat-content" style={{ left: 0 }}>

                    <div className="chat-content-header">
                        <h6 className="mg-b-0">#AI Prompt</h6>
                    </div>

                    <div className="chat-content-body">
                        <div className="chat-group">

                            {messages.map((msg, index) => (
                                <div className="media" key={index}>
                                    <div className="avatar avatar-sm avatar-online">
                                        <span className="avatar-initial rounded-circle">
                                            {msg.role === "user" ? "U" : "A"}
                                        </span>
                                    </div>

                                    <div className="media-body">
                                        <h6>
                                            {msg.role === "user" ? "You" : "AI"}
                                            <small> • {msg.time}</small>
                                        </h6>

                                        <p style={{ whiteSpace: "pre-wrap" }}>
                                            {msg.content}
                                        </p>
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>
                </div>
            </div>

            <div className="chat-content-footer">
                <span className="chat-plus"><i data-feather="message-square"></i></span>

                <input
                    id="prompt"
                    type="text"
                    className="form-control align-self-center bd-0 pl-4"
                    placeholder="Message"
                    onKeyPress={handleKeyPress}
                />

                <nav>
                    {loading ? (
                        <span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"></span>
                    ) : (
                        <a onClick={sendMessage} style={{ cursor: "pointer" }}>
                            <i data-feather="send"></i>
                        </a>
                    )}
                </nav>
            </div>
        </div>
    );
};

export default Chatbot;
